<template>
  <div v-show="toShow" class="cross-sell-container">
    <slot name="title">
      <h4 class="cross-sell-title">Often Purchased With</h4>
    </slot>
    <ProductCarousel
      v-slot:customProductTitle="{ productTitle }"
      class="cross-sell-products-carousel"
      :products="products"
      :slides-per-view="productsPerView"
      :space-between="20"
      :show-pagination="true"
      :swiper-margin="false"
      :slide-breakpoints="slideBreakpoints"
      :small-arrows="true"
      :carousel-padding="20"
      :show-add-to-cart-btn="true"
      :open-in-new-tab="true"
      :animate-cart-btn="animateCartBtn"
      @productAddedToCart="(product) => onProductAddedToCart(product)"
      @loaded="onCarouselLoad"
      @productClicked="onProductClicked"
    >
      <h2 class="product-title">{{ productTitle }}</h2>
    </ProductCarousel>
  </div>
</template>

<script>
import ProductCarousel from '@/components/commons/ProductCarousel.vue';

const MIN_PRODUCT_COUNT = 3;

export default {
  name: 'CrossSell',
  components: {
    ProductCarousel,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    productsPerView: {
      type: Number,
      default: 3,
    },
    animateCartBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      slideBreakpoints: {
        1366: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        959: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
      carouselLoaded: false,
    };
  },
  computed: {
    toShow() {
      return this.products?.length >= MIN_PRODUCT_COUNT && this.carouselLoaded;
    },
  },
  methods: {
    onCarouselLoad() {
      this.carouselLoaded = true;
    },
    onProductAddedToCart(product) {
      this.$emit('productAddedToCart', product);
    },
    onProductClicked() {
      this.$emit('productClicked');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@article/pixel/dist/style/variables';

.cross-sell-container {
  overflow: hidden;
  transition: height 200ms ease-out;

  .cross-sell-title {
    margin-left: 20px;
  }

  margin: 0px -20px;

  .product-title {
    font-size: 1em;
    color: var(--grey-medium);
    text-transform: none;
    letter-spacing: unset;
  }
}
</style>
